import { type PaginatedResponse } from '@/types/pagination';
import { makeRequestActionCreator } from '@/utils';
import { type Competitor, type Logo } from './types';
import { logosSlice } from './slice';

const createRequestAction = makeRequestActionCreator(logosSlice.name);

export const fetchCompetitors = createRequestAction<
  { search?: string; missingLogo?: boolean; page?: number },
  PaginatedResponse<Competitor>
>('fetchCompetitors');

export const fetchCollection = createRequestAction<
  { search?: string },
  PaginatedResponse<Logo>
>('fetchCollection');

export const setNewLogo = createRequestAction<
  { logoUrl?: string; externalId?: string },
  PaginatedResponse<Competitor>
>('setNewLogo');

export const {
  setCompetitors,
  setCompetitorsPagination,
  setCollection,
  setLoading,
  setError,
  setTeamLogo,
  clearTeamLogos,
} = logosSlice.actions;
